import React, { Component } from 'react'

import style from './Grid.css'

export default class Col extends Component {
  
  render() {
  
    var className = ''
    if(this.props.sm)
        className = style.hiddenSM
    
    if(this.props.lg)
        className = style.hiddenLG
        
    return (
      <span
        className={className}
        style={this.props.style}
        >
        {this.props.children}
      </span>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/atoms/Grid/Hidden.js